import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const trigger = event.currentTarget
    const item = trigger.closest("[data-accordion-target='item']")
    const isOpen = item.classList.contains("ex-faq-item--open")

    this.itemTargets.forEach((el) => el.classList.remove("ex-faq-item--open"))

    if (!isOpen) {
      item.classList.add("ex-faq-item--open")
    }
  }
}
